/** Path to the report variables editor (single Skisse-based UI). */
export function reportVariablesPagePath(reportId) {
  return `/dashboard/service/reports/${reportId}/variables`;
}

/** Calendar cutover (Europe/Oslo on server). Must match Report::NEW_VARIABLES_SYSTEM_FROM. */
export const NEW_VARIABLES_SYSTEM_FROM_DATE = "2026-05-24";

/**
 * Reports created before the cutover use the legacy variable editor.
 * Prefer API field `uses_legacy_variables` (server compares created_at in app time zone).
 */
export function reportUsesLegacyVariables(report) {
  if (report == null) return true;
  if (report.uses_legacy_variables != null) {
    return !!report.uses_legacy_variables;
  }
  if (!report.created_at) return true;

  const created = new Date(report.created_at);
  if (Number.isNaN(created.getTime())) return true;

  const cutover = new Date(`${NEW_VARIABLES_SYSTEM_FROM_DATE}T00:00:00`);
  return created < cutover;
}

/**
 * Use ReportSectionDialog + classic ReportVariables instead of the V2 variables page.
 * True for reports created before the V2 cutover date (2026-05-24).
 */
export function shouldOpenLegacyVariablesDialog(report) {
  return reportUsesLegacyVariables(report);
}

/** Report has any variable payload worth offering to copy (rows, V2 groups, or type groups). */
export function reportHasVariableDataForCopy(report) {
  if (!report) return false;
  const vars = report.variables;
  if (Array.isArray(vars) && vars.length > 0) return true;
  const groups = report.variable_groups;
  if (Array.isArray(groups) && groups.length > 0) return true;
  const typeGroups = report.variable_type_groups;
  if (Array.isArray(typeGroups) && typeGroups.length > 0) return true;
  return false;
}

/** Classic field1/field2 rows without groups (shown as legacy section on V2 page). */
export function isLegacyStyleReportVariable(variable) {
  if (!variable || variable.delete) return false;
  const hasOldFields = !!(
    variable.field1 ||
    variable.field2 ||
    variable.field_one ||
    variable.field_two
  );
  const hasNoGroup = !variable.group_id;
  const hasNoTypeGroup = !variable.type_group_id;
  const hasNoMeasurements = !variable.measurements || variable.measurements.length === 0;
  const isNotMainVariable = !variable.is_main_variable;
  return hasOldFields && hasNoGroup && hasNoTypeGroup && hasNoMeasurements && isNotMainVariable;
}
